/**
 * 浏览器入口文件。
 *
 * 执行顺序：加载全局样式 -> 找到 index.html 中的 #root -> 创建 React 根节点
 * -> 渲染 App。整个网站只有一个 React 页面，场景切换由滚动位置控制。
 */
import './css/app.css';
// 二次开发样式放在这里；后加载，因此能覆盖原站的压缩 CSS。
import './css/overrides.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// index.html 保证存在 #root；这里把普通 DOM 节点交给 React 管理。
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);
root.render(
    // StrictMode 只在开发环境帮助发现副作用，生产构建不会重复渲染组件。
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// 当前不传回调，因此不会收集指标；调试时可改为 reportWebVitals(console.log)。
reportWebVitals();
